import React from "react";
import classNames from "classnames";
import { List as L } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function List({ element, height, width, progress }: Props) {
  const { startDate, endDate } = element as L;
  const withStartDate = !!startDate && !endDate;
  const withEndDate = !startDate && !!endDate;

  return (
    <svg
      className={classNames(styles.list, {
        [styles.project]: element.isProject,
        [styles.unScheduled]: !startDate || !endDate,
        [styles.withStartDate]: withStartDate,
        [styles.withEndDate]: withEndDate,
        [styles.completed]: progress === 100,
      })}
      width={width}
      height={height}
    >
      <defs>
        <linearGradient id="withStartDate">
          <stop offset="0" stopColor="#395786" />
          <stop offset="50%" stopColor="#DFEBFD" />
        </linearGradient>
        <linearGradient id="withEndDate">
          <stop offset="0" stopColor="#DFEBFD" />
          <stop offset="50%" stopColor="#395786" />
        </linearGradient>
      </defs>
      <path
        fill={
          withStartDate
            ? "url(#withStartDate)"
            : withEndDate
              ? "url(#withEndDate)"
              : undefined
        }
        d={`
            M0 10
            C0 0, 0 0, 10 0
            H${width - 10}
            C${width} 0, ${width} 0, ${width} 10
            V${height}
            L${width - 10} ${height - height * 0.25}
            H${10}
            L0 ${height}
            Z
        `}
      />
    </svg>
  );
}

export { List };
